import { render, staticRenderFns } from "./MapSwitzerland.vue?vue&type=template&id=5eeb4fea&"
import script from "./MapSwitzerland.vue?vue&type=script&lang=js&"
export * from "./MapSwitzerland.vue?vue&type=script&lang=js&"
import style0 from "./MapSwitzerland.vue?vue&type=style&index=0&id=5eeb4fea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports